module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-index"
  }, _vm._l((_vm.menu), function(menuItem, index) {
    return _c('grid', {
      key: index,
      attrs: {
        "rows": 3
      }
    }, _vm._l((menuItem), function(item) {
      return _c('grid-item', {
        key: item.name,
        staticClass: "grid-center",
        attrs: {
          "label": item.name
        },
        nativeOn: {
          "click": function($event) {
            _vm.goPath(item.path)
          }
        }
      }, [_c('span', {
        class: item.icon,
        attrs: {
          "slot": "icon"
        },
        slot: "icon"
      })])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb435fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/AppIndex.vue
// module id = 249
// module chunks = 0